import { render, staticRenderFns } from "./THGTagInput.vue?vue&type=template&id=090d54f9"
import script from "./THGTagInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGTagInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports